/* 
    This store is used to manage the rights of the authed user on different views.
*/
import { getRequest, apiDomain } from '@/System/Store/endpoints';

const initialState = () => ({
    dashboard: {
        create: false,
        read: false,
        update: false,
        delete: false,
    },
    certificates: {
        create: false,
        read: false,
        update: false,
        delete: false,
    },
    competences: {
        internal: {
            create: false,
            read: false,
            update: false,
            delete: false,
        },
        external: {
            create: false,
            read: false,
            update: false,
            delete: false,
        },
    },
    expertises: {
        create: false,
        read: false,
        update: false,
        delete: false,
    },
    employees: {
        create: false,
        read: false,
        update: false,
        delete: false,
    },
    teams: {
        create: false,
        read: false,
        update: false,
        delete: false,
    },
    payments: {
        create: false,
        read: false,
        update: false,
        delete: false,
    },
    settings: {
        create: false,
        read: false,
        update: false,
        delete: false,
    },
});

const state = initialState();

const mutations = {
    SET_ALL_PERMISSIONS: (state, obj) => Object.assign(state, obj),
    SET_SINGLE_PERMISSION: (state, payload) => (state[payload.key] = payload.permissions),
};

const actions = {
    async FETCH_USER_PERMISSIONS({ commit }, profileId) {
        const response = await getRequest(`${apiDomain}/users/${profileId}/permissions`);
        if (response.status === 'Success') {
            commit('SET_ALL_PERMISSIONS', response.data);
        }
    },
};

const getters = {
    GET_ALL_PERMISSIONS: (state) => state,
    GET_SINGLE_PERMISSION: (state) => (key) => state[key],
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
